"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useWindowSize = require("./useWindowSize");
Object.keys(_useWindowSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useWindowSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useWindowSize[key];
    }
  });
});